var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClinicalSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5893 1.91084C10.512 1.83338 10.4202 1.77194 10.3191 1.73001C10.218 1.68808 10.1096 1.6665 10.0001 1.6665C9.8907 1.6665 9.78233 1.68808 9.68124 1.73001C9.58014 1.77194 9.4883 1.83338 9.41098 1.91084L1.91098 9.41084C1.79447 9.52738 1.71513 9.67585 1.683 9.83748C1.65086 9.99911 1.66736 10.1666 1.73042 10.3189C1.79347 10.4711 1.90026 10.6013 2.03727 10.6928C2.17427 10.7844 2.33536 10.8333 2.50015 10.8333H3.33348V16.6667C3.33348 17.5858 4.08098 18.3333 5.00015 18.3333H15.0001C15.9193 18.3333 16.6668 17.5858 16.6668 16.6667V10.8333H17.5001C17.6651 10.8337 17.8265 10.785 17.9637 10.6935C18.101 10.602 18.208 10.4718 18.2711 10.3194C18.3343 10.167 18.3507 9.99925 18.3183 9.83749C18.2859 9.67572 18.2062 9.52723 18.0893 9.41084L10.5893 1.91084ZM15.001 16.6667H5.00015V8.67834L10.0001 3.67834L15.0001 8.67834V12.5L15.001 16.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 8.33337H9.1665V10.8334H6.6665V12.5H9.1665V15H10.8332V12.5H13.3332V10.8334H10.8332V8.33337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClinicalSummary);
export default __webpack_public_path__ + "static/media/ic-clinical-summary.5f2598e4700f27369c205d61791bf6cc.svg";
export { ForwardRef as ReactComponent };